import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { LocationsProvider } from '../locations/locations';

@Injectable()
export class ConfigProvider {
  constructor(private api: ApiProvider, private locationsProvider: LocationsProvider) {
    // this.locationsProvider.getUserLocation();

  }

  load(appId:number) :Promise<AppConfig>{
    const query = `{
      app(id:${appId}){
        id,name,description,clientId
        searchLinks{text,url}
        settings
        mode
        demo
        pinless
        staff
        scrollArrows
        timeoutInterval
        sharedScreen
        autologoutPosition
        libraryCardPlaceholderImg
        hideHeaderLogo
        locationId
        promptForLocation
        enableOnScreenKeyboard
        htmlKeyboard
        enableSounds
				header{html}
        footer{html}
        burgerMenu {
          title
          menuSide
          items {
            ... on BlockInterface{
              id,title,type,css,square,css,icon,html,embedded,settings
            }
            ... on URLBlockType{
              url
            }
            ... on ScreenBlockType{
              name
            }
            ... on WidgetBlockType{
              widgetId widget { name options data }
            }
            ... on PageBlockType{
              PageId
            }
            ... on NewsBlockType{
              items{
                title, image, text, link
              }
            }
            ... on HTMLBlockType{
              html
            }
            ... on ReserveBlockType{
              mode, locationId, roomIds, currentDayOnly, libraryCardRequired, hideLibraryCardAndPin, hideScheduleTab, expandRoomDetails, roomTitleFontSize, roomBookerLabel, scheduleLabel, showScheduleNames, hideNotes, disableRightClick, tcOptional, branches, overrideSetRequireEmailTo, overrideSetRequirePhoneTo, showEmailInput, showPhoneInput, hideBookingTitle, showPartialPatronDetails, tcHideCartLink, showFullName, requirePhone, requireEmail
            }
            ... on AttendBlockType{
              mode, locationId
            }
            ... on ZinioBlockType{
              picks {
                name, direction, titles
              }
            }
          }
        }
    		theme {
          id
          outerFrameColor
          backgroundColor
          pageColor
          searchFrameColor
          font
          pageFontColor
          linkColor
          linkHoverColor
          linkStyle
          linkWeight
          widgetBorderColor
          widgetBorderSize
          widgetBorderRadius
          widgetHeaderColor {
            split,color1,color2,color3,color4
          }
          widgetHeaderWeight
          widgetTitleTextColor
          widgetSubheadingColor
          widgetBodyColor
          widgetDividing_ruleColor
          widgetMovable
          widgetTabActiveTextColor
          widgetTabActiveBackgroundColor
          widgetTabInactiveTextColor
          widgetTabInactiveBackgroundColor
          tabBorderSize
          tabFrameColor
          tabTextColor
          tabWeight
          tabBorderRadius
          tabBarBackgroundColor {
            split,color1,color2,color3,color4
          }
          tabBackgroundColor {
            split,color1,color2,color3,color4
          }
          tabHoverFrameColor
          tabHoverTextColor
          tabBackgroundHoverColor {
            split,color1,color2,color3,color4
          }
          buttonFrameColor
          buttoBorderSize
          buttonTextColor
          buttonWeight
          buttonBackgroundColor {
            split,color1,color2,color3,color4
          }
          buttonHoverTextColor
          buttonHoverFrameColor
          buttonBackgroundHoverColor {
            split,color1,color2,color3,color4
          }
          buttonBorderRadius
          widgetShadowColor
          widgetShadowSize
          widgetShadowSpread
          widgetShadowOffset
          widgetBorderAlpha
          footerLinkColor
          headerLogo
          welcomeText
          useAltWelcome
          altWelcomeText
          headerTextColor
          headerTextWeight
          headerBackgroundColor {
            split,color1,color2,color3,color4
          }
          headerPixelWidth
          headerRowPixelWidth
          bodyPixelWidth
          body_RwPixelWidth
          footerPixelWidth
          footerRowPixelWidth
        }
        screens{
          name,
          css,
          settings,
          rowCSS,
          title,
          layout,
          enableFooter,
          menuSide,
          menuWidth,
          footerBlocks {
            ... on BlockInterface{ id,title,type,css,square,css,icon,settings,html,embedded }
            ... on URLBlockType{ url }
            ... on ScreenBlockType{ name }
            ... on WidgetBlockType{
              widgetId widget { name options data }
            }
            ... on PageBlockType{ PageId }
            ... on NewsBlockType{
              items{
                title, image, text, link
              }
            }
            ... on HTMLBlockType{
              html
            }
            ... on HTMLBlockType{ html }
            ... on RecommendedBlockType {
              moreText moreLinkText widgetId
            }
            ... on ReserveBlockType{ mode, locationId, roomIds, currentDayOnly, expandRoomDetails, roomTitleFontSize, roomBookerLabel, scheduleLabel, libraryCardRequired, hideLibraryCardAndPin, hideScheduleTab, showScheduleNames, hideNotes, disableRightClick, tcOptional, branches, overrideSetRequireEmailTo, overrideSetRequirePhoneTo, showEmailInput, showPhoneInput, hideBookingTitle, showPartialPatronDetails, tcHideCartLink, showFullName, requirePhone, requireEmail }
            ... on AttendBlockType{ mode, locationId, settings }
            ... on CheckoutBlockType{ branchId }
            ... on ZinioBlockType{
              picks {
                name, direction, titles
              }
            }
          }
          blocks{
            ... on BlockInterface{ id,title,type,css,square,css,icon,settings,html,embedded }
            ... on URLBlockType{ url }
            ... on ScreenBlockType{ name }
            ... on WidgetBlockType{
              widgetId widget { name options data }
            }
            ... on PageBlockType{ PageId }
            ... on NewsBlockType{
              items{
                title, image, text, link
              }
            }
            ... on HTMLBlockType{
              html
            }
            ... on SecurityBlockType {
              id, form, buttons {
                text
                type
                color
              }, messages {
                name
                message
              }, departments {
                name, contacts {
                  type
                  data
                }
              }
            }
            ... on HTMLBlockType{ html }
            ... on RecommendedBlockType {
              moreText moreLinkText widgetId
            }
            ... on ReserveBlockType{ mode, locationId, roomIds, currentDayOnly, expandRoomDetails, roomTitleFontSize, roomBookerLabel, scheduleLabel, libraryCardRequired, hideLibraryCardAndPin, hideScheduleTab, showScheduleNames, hideNotes, disableRightClick, tcOptional, branches, overrideSetRequireEmailTo, overrideSetRequirePhoneTo, showEmailInput, showPhoneInput, hideBookingTitle, showPartialPatronDetails, tcHideCartLink, showFullName, requirePhone, requireEmail }
            ... on AttendBlockType{ mode, locationId, settings }
            ... on CheckoutBlockType{ branchId, pinless }
            ... on ZinioBlockType{
              picks {
                name, direction, titles
              }
            }
          }
        }
      }
    }`;
    return this.api.getData(query, 'id', appId);
  }

  getAllApps(type?: string): Promise<Array<AppConfig>>{
      const query = `{
        allApps${(type ? '(type:"'+type+'")':'')} {
        id, name, clientId
        }
      }`
    return this.api.getDataArray(query, 'id');
  }
}

export interface AppConfig{
  id: number,
  name: string,
  description: string,
  clientId: number,
  searchLinks?,
  settings,
  header: Header,
  footer: Footer,
  theme,
  screens: ReadonlyArray<AppScreen>,
  mode?: string,
  demo?: boolean,
  sharedScreen: boolean
  burgerMenu?: any;
  staff: boolean;
  scrollArrows: boolean;
  timeoutInterval: number;
  locationId: number;
  promptForLocation: boolean;
  enableSounds: boolean;
}
export interface BurgerMenu {
  title: string,
  items: ReadonlyArray<{id: string, title: string}>
}
export interface Header{
  id: number,
  name: string,
  html: string
}
export interface Footer{
  id: number,
  name: string,
  html: string
}
export interface AppScreen{
  name: string,
  title: string,
  css?: ReadonlyArray<any>,
  settings?: any,
  layout?: ReadonlyArray<Array<AppLayout>>,
  blocks: ReadonlyArray<AppBlock>,
  enableFooter: boolean,
  footerBlocks?: ReadonlyArray<AppBlock>,
  menuSide?: string,
  menuWidth?: string
}
export interface AppLayout{
  id: number,
  attributes: ReadonlyArray<string>
}
export interface AppBlock{
  id?: string
  title: string,
  icon: string,
  name?: string,
  type: string,
  html?: string,
  css?: ReadonlyArray<any>,
  square?: boolean,
  url?: string,
  settings?: object,
}
export interface ReserveBlock extends AppBlock{
  overrideSetRequirePhoneTo?: boolean,
  overrideSetRequireEmailTo?: boolean,
  locationId?:number,
  mode?: string,
  roomIds?: ReadonlyArray<number>,
  currentDayOnly?: boolean,
  embedded?: boolean,
  settings?: object,
  hideNotes?: boolean,
  disableRightClick?: boolean,
  tcOptional?: boolean,
  branches?: any,
  showEmailInput?: boolean,
  showPhoneInput?: boolean,
  requirePhone?: boolean,
  requireEmail?: boolean,
  hideBookingTitle?: boolean,
  showPartialPatronDetails?: boolean,
  expandRoomDetails?: boolean,
  roomTitleFontSize?: string,
  roomBookerLabel?: string,
  scheduleLabel?: string,
  libraryCardRequired?: boolean,
  hideLibraryCardAndPin?: boolean,
  hideScheduleTab?: boolean,
  showScheduleNames?: boolean,
  tcHideCartLink?: boolean,
  showFullName?: boolean
}
export interface coButton {
  text: string;
  full: boolean;
  color: string;
  icon: string;
  square?: boolean,
  linkURL?: string;
  block?: AppBlock;
}


// WEBPACK FOOTER //
// ./src/providers/config/config.ts